import { useMemo } from 'react'

import { Table, cn } from 'twyne-new.ui'

import { TableResizeProvider } from '@Components/tableResize/context'
import { useInicializeTableResize } from '@Components/tableResize/hooks'
import { PinnedColumnsProvider, usePinnedColumns } from '@Components/tableResize/pinned'

import Body from './Body'
import { Header } from './Header'
import NoContent from './NoContent'

const DefaultTableResizeContent = ({
  columns, data, noDataIndication, rowClassName, keyField = 'id', className = '', rowWrapper, footer,
  sticky = true, fixedFistColumnOnScroll = false, onTogglePinColumn, onRemoveColumn, onReorderColumns,
  onSortColumn, sortState, onOpenColumnsConfig,
}) => {
  const { hadResized, onResize } = useInicializeTableResize({ columns })
  const pinnedIndexes = useMemo(() => resolvePinnedIndexes(columns, fixedFistColumnOnScroll), [columns, fixedFistColumnOnScroll])

  return <PinnedColumnsProvider pinnedIndexes={pinnedIndexes} columns={columns}>
    <div className='relative'>
      <Table className={cn('w-full', hadResized && 'table-fixed')} containerClassName={className}>
        <Header
          columns={columns}
          sticky={sticky}
          onResize={onResize}
          onTogglePinColumn={onTogglePinColumn}
          onRemoveColumn={onRemoveColumn}
          onReorderColumns={onReorderColumns}
          onSortColumn={onSortColumn}
          sortState={sortState}
          onOpenColumnsConfig={onOpenColumnsConfig}
        />
        <PinnedBody
          data={data}
          columns={columns}
          rowClassName={rowClassName}
          keyField={keyField}
          rowWrapper={rowWrapper}
        />
        {footer}
      </Table>
      <NoContent data={data} noDataIndication={noDataIndication} />
    </div>
  </PinnedColumnsProvider>
}

function PinnedBody(props) {
  const { pinnedIndexes, offsets } = usePinnedColumns()
  return <Body {...props} pinnedIndexes={pinnedIndexes} offsets={offsets} />
}

function resolvePinnedIndexes(columns, fixedFistColumnOnScroll) {
  const hasFlags = columns.some(column => column.pinned !== undefined || column.alwaysPin)
  if (hasFlags) {
    return columns.reduce((indexes, column, index) => column.pinned || column.alwaysPin ? [...indexes, index] : indexes, [])
  }

  return fixedFistColumnOnScroll && columns.length ? [0] : []
}

export default function DefaultTableResize(props) {
  return <TableResizeProvider>
    <DefaultTableResizeContent {...props} />
  </TableResizeProvider>
}
